'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _parseInt = require('babel-runtime/core-js/number/parse-int');

var _parseInt2 = _interopRequireDefault(_parseInt);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.getFieldAggregate = getFieldAggregate;
exports.getFieldData = getFieldData;
exports.onePointPerHour = onePointPerHour;
exports.modifyResultTimeToMillisecs = modifyResultTimeToMillisecs;
exports.zipUpResults = zipUpResults;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFieldAggregate(ioBeamData, field, overDays) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'mean';

  var afterTime = Date.now() - 24 * 60 * 60 * 1000 * overDays;

  if (!ioBeamData) {
    return undefined;
  }

  var columnFieldIndex = ioBeamData.fields.findIndex(function (val) {
    return val === field;
  });
  if (columnFieldIndex === -1) {
    return undefined;
  }

  var sum = 0;
  var numOfValues = 0;
  // Filter out only values that are after the timestamp
  // And whose value isn't zero
  var timeFrameValues = ioBeamData.values.filter(function (val) {
    return val[0] > afterTime && val[columnFieldIndex] !== 0;
  });

  // eslint-disable-next-line no-restricted-syntax
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(timeFrameValues), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var val = _step.value;

      if (val[columnFieldIndex] !== null) {
        sum += val[columnFieldIndex];
        numOfValues += 1;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (type === 'sum') {
    return sum;
  }
  if (type === 'mean') {
    return sum / numOfValues;
  }
  return undefined;
}

function getFieldData(ioBeamData, field) {
  var modifyFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (val) {
    return val;
  };

  if (!ioBeamData) {
    return undefined;
  }

  var columnFieldIndex = ioBeamData.fields.findIndex(function (val) {
    return val === field;
  });
  if (columnFieldIndex === -1) {
    return undefined;
  }

  var outputArray = [];

  // eslint-disable-next-line no-restricted-syntax
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(ioBeamData.values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var val = _step2.value;

      var yValue = modifyFunc(val[columnFieldIndex]);
      if (yValue !== null) {
        outputArray.push({
          x: val[0],
          y: yValue
        });
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return outputArray;
}

function onePointPerHour(data) {
  var newValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  /**
   * This function takes in an output iobeam dataset and ensures that there
   * is at least one point of data (newValue, default 0) every hour
   */

  if (!data || data.length <= 1) {
    return data;
  }

  // New timestamps to add to make data once per hour
  var newDataToAppend = [];

  // Check if timestamp is within 1 hour = 1000 s/ms * 60 min/s * 60 h/min
  var diffOfTimestamps = 1000 * 60 * 60;

  // Keep track of last timestamp
  var lastTimestamp = data[data.length - 1].x;

  // Iterate in reverse order since array is sorted in reverse chronological order
  for (var index = data.length - 1; index >= 0; index -= 1) {
    var row = data[index];
    // 1.5 is for margin, if the last timestamp is within 1.5 hours we're ok
    // Keep checking if we have added enough values to make new timestamp within 1 hour
    while (row.x - lastTimestamp > diffOfTimestamps * 1.5) {
      lastTimestamp += diffOfTimestamps;
      newDataToAppend.push({
        x: lastTimestamp, // Use the new lastTimestamp as the new timestamp
        y: newValue // Insert new value in timestamp
      });
    }

    // Save timestamp for next iteration
    lastTimestamp = row.x;
  }

  // Other code logic assumes that the array is sorted in reverse chronological order
  return data.concat(newDataToAppend).sort(function (aa, bb) {
    return bb.x - aa.x;
  });
}

/**
 * Determines if the data (from dynamoDB or ioBeam) is empty
 * @param  {Object}  data  Data from iobeam/dynamodb
 * @return {Boolean}       If it's empty
 */
function isDataEmpty(data) {
  return !data || !data.values || data.values.length === 0;
}

/**
 * Takes in a time in seconds and turns it into one in milliseconds
 * @param  {Object} dataInSeconds Full data payload from dynamoDB
 *                                where time is in seconds
 * @return {Object}               Copied transformed version in ms
 * @warning: Assumes that the time is the first element in values
 */
function modifyResultTimeToMillisecs(dataInSeconds) {
  if (isDataEmpty(dataInSeconds)) {
    return dataInSeconds;
  }
  var values = dataInSeconds.values.map(function (_ref) {
    var _ref2 = (0, _toArray3.default)(_ref),
        time = _ref2[0],
        rest = _ref2.slice(1);

    return [time * 1000].concat((0, _toConsumableArray3.default)(rest));
  });
  return (0, _extends3.default)({}, dataInSeconds, {
    values: values
  });
}

/**
 * Internal helper that creates an output data array in the same order
 * as the fields passed in. This allows remapping an arbitrary order
 * supplied by iobeam / DynamoDB into whatever needed order
 * @param  {List} intersectionFields - Fields to map with
 * @param  {Object} data             - Data source from iobeam / dynamoDB
 *
 * @return {List} - Output list of data in order of intersectionFields
 */
function remapValuesToFields(intersectionFields, data) {
  // Each field has the index of the corresponding
  // field in the incoming data object
  var fieldMapping = intersectionFields.map(function (field) {
    return data.fields.indexOf(field);
  });

  // Loop through each of the rows transforming each one to the
  // indices defined by intersectionFields
  var outputValuesArray = data.values.map(function (rowOfData) {
    var outputRow = [];
    // For each element in the field mapping grab the appropriate
    // entry from the row of data
    for (var i = 0; i < fieldMapping.length; i += 1) {
      outputRow.push(rowOfData[fieldMapping[i]]);
    }
    return outputRow;
  });

  return outputValuesArray;
}

/**
 * Sorts data a data source (eg iobeam / dynamoDB)
 * @param  {object} data - Data source (eg: iobeam/dynamoDB)
 * @return {object} Output data source of the same format
 */
function sortRowsOfData(data) {
  if (isDataEmpty(data)) {
    return data;
  }
  var values = data.values.sort(function (rowOne, rowTwo) {
    return (0, _parseInt2.default)(rowTwo[0], 10) - (0, _parseInt2.default)(rowOne[0], 10);
  });
  return (0, _extends3.default)({}, data, {
    values: values
  });
}

/**
 * Combine two different data sources into one, using the intersection
 * of fields in both of them.
 * (We expect dynamoDB to be a strict subset of ioBeam, and therefore the full set)
 * @param  {object} dataOne - Data source (eg: iobeam/dynamoDB)
 * @param  {object} dataTwo - Data source (eg: iobeam/dynamoDB)
 *
 * @return {object} Output data source of the same format
 */
function zipUpResults(dataOne, dataTwo) {
  // If the data is empty in either of these two, use the other one.
  if (isDataEmpty(dataOne)) {
    return sortRowsOfData(dataTwo);
  }
  if (isDataEmpty(dataTwo)) {
    return sortRowsOfData(dataOne);
  }

  // Finds all of the fields that exist in both (intersection)
  var dataTwoFields = new _set2.default(dataTwo.fields);
  var intersectionFields = dataOne.fields.filter(function (x) {
    return dataTwoFields.has(x);
  });

  // Combine return values from both of the data sources
  var returnValues = remapValuesToFields(intersectionFields, dataOne);
  returnValues = returnValues.concat(remapValuesToFields(intersectionFields, dataTwo));

  return sortRowsOfData({
    fields: intersectionFields,
    values: returnValues
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/ioBeamUtils.js
 ** module id = 1406
 ** module chunks = 0
 **/